import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getMobilebanner,
  editMobilebanner,
} from "../../store/actions/mobilebanners_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import {
  initialValues,
  inputFields,
} from "../../shared/enums/mobilebanners_enum";

const EditMobilebanner = ({
  editMobilebanner,
  getMobilebanner,
  match,
  mobilebanner: { loading, mobilebanner },
}) => {
  let history = useHistory();
  useEffect(() => {
    getMobilebanner(match.params.id);
  }, [match]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const submitMobilebanner = async (values) => {
    if (featuredImage || gallery) {
      const images = await upload(featuredImage, gallery);
      if (images) {
        if (images.featured_image) {
          values.featured_image = images.featured_image;
        }
        if (images.gallery_images) {
          values.gallery = images.gallery_images;
        }
      }
    }
    await editMobilebanner(mobilebanner.id, values);
    history.push(`/mobilebanners/${mobilebanner.id}/view`);
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Edit Mobilebanner"
          mainLinkTitle="Mobilebanners"
          mainLinkUrl="/mobilebanners"
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!loading ? (
              mobilebanner && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {mobilebanner.title} - <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link
                          to="/mobilebanners"
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-angle-left"></i> Mobilebanners
                        </Link>
                        <Link
                          to={`/mobilebanners/${mobilebanner.id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={mobilebanner}
                    edit={true}
                    featuredImage={featuredImage}
                    gallery={gallery}
                    setFeaturedImage={setFeaturedImage}
                    setGallery={setGallery}
                    submitForm={submitMobilebanner}
                    inputFields={inputFields}
                    initialValues={initialValues}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  alert: state.alert,
  mobilebanner: state.mobilebanner,
});

const mapDispatchToProps = { editMobilebanner, getMobilebanner };

export default connect(mapStateToProps, mapDispatchToProps)(EditMobilebanner);
